import { Theme } from '@mui/material';

export const sxNewAddressContainer = (isOpen: boolean) => (theme: Theme) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  transition: theme.transitions.create('all'),
  ...(isOpen && {
    boxShadow: theme.customShadows.z12,
  }),
  p: 3,
  gap: 3,
  mb: 1,
});
